module.exports = __webpack_public_path__ + "static/media/good-inactive.2261c83e.svg";